module.exports = __webpack_public_path__ + "img/home_workflow.dd660d1d.png";